<template>
  <div v-if="canOrderSamples" class="sample-order-module">
    <img src="/images/sample-order.png" alt="" />
    <div class="module-content">
      <div>
        <strong>{{ $t('SAMPLE_ORDER.DASHBOARD.HEADING') }}</strong>
        <p>{{ $t('SAMPLE_ORDER.DASHBOARD.TEXT') }}</p>
      </div>
      <button class="btn btn-primary icon-btn" @click="orderSamples">
        <Icon icon="shipping-box" />
        {{ $t('SAMPLE_ORDER.ENTRY_POINT') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * The dashboard entry point into a sample order. It hides itself when the partner has no channel to
 * order from, so `Dashboard` does not repeat the condition — the same shape as `SampleOrderButton`.
 */
import { computed } from 'vue';
import { canStartSampleOrder } from 'commons/sampleOrder/sampleOrderChannels';
import { openSampleOrderEntry } from 'commons/sampleOrder/sampleOrderEntry';
import {
  SAMPLE_ORDER_SOURCE,
  trackSampleOrderEntryClick,
} from 'commons/sampleOrder/sampleOrderTracking';

const canOrderSamples = computed(() => canStartSampleOrder());

const orderSamples = () => {
  trackSampleOrderEntryClick({ source: SAMPLE_ORDER_SOURCE.DASHBOARD });

  return openSampleOrderEntry({
    source: SAMPLE_ORDER_SOURCE.DASHBOARD,
  }).catch(() => {
    // Backing out of the dialog rejects; there is nothing to do about it here.
  });
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/constants';

.sample-order-module {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 24px;

  & > img {
    flex-shrink: 0;
    width: 150px;
    height: 150px;
    border-radius: $border-radius-medium;
  }

  .module-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }

  p {
    margin: 12px 0 0 0;
    color: $grey65;
  }
}
</style>
